import { createSelector } from 'reselect';

import options from './options';

const { name } = options;

export const getSoilTypeCatalog = state => state.models[name].data;
export const getCurSoilType = state => state.models[name].item;